"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeDomainForClaim = normalizeDomainForClaim;
exports.isValidDomainForClaim = isValidDomainForClaim;
/**
 * Normalizes user/admin input into a DNS hostname shape for domain-claim keys and TXT checks.
 * Does not perform IDN punycode encoding; admins should enter ASCII or punycode (xn--…) labels.
 */
function normalizeDomainForClaim(domain) {
    let s = String(domain || '')
        .trim()
        .toLowerCase()
        .replace(/^@+/, '')
        .replace(/^https?:\/\//, '')
        .split('/')[0];
    s = s.replace(/\.+$/, '');
    return s;
}
const MAX_HOSTNAME_LENGTH = 253;
const MAX_LABEL_LENGTH = 63;
/**
 * Per-label: letters, digits, hyphen; no leading/trailing hyphen; 1–63 chars.
 * Allows typical punycode labels (e.g. xn--…) since they use the same character set.
 */
function isValidHostnameLabel(label) {
    if (label.length === 0 || label.length > MAX_LABEL_LENGTH) {
        return false;
    }
    if (label.startsWith('-') || label.endsWith('-')) {
        return false;
    }
    return /^[a-z0-9-]+$/.test(label);
}
/**
 * True when the input normalizes to a plausible multi-label DNS hostname for org domain claim / TXT verification.
 */
function isValidDomainForClaim(domainInput) {
    const normalized = normalizeDomainForClaim(domainInput);
    if (!normalized || normalized.length > MAX_HOSTNAME_LENGTH) {
        return false;
    }
    const labels = normalized.split('.');
    if (labels.length < 2) {
        return false;
    }
    if (labels.some((label) => label.length === 0)) {
        return false;
    }
    return labels.every(isValidHostnameLabel);
}
